/* HUSHLY — offre par packs sur la fiche produit.
   Meme balisage et meme feuille de style que le bloc d'achat de l'accueil.
   Difference unique et voulue : ce bloc n'a PAS de formulaire a lui.
   Il pilote le formulaire de main-product (#product-form-<section>) :
     - le palier choisi coche une radio native cachee, ce qui laisse Dawn
       recalculer la variante, le prix, l'etat du bouton et l'URL ;
     - l'age du 1er oreiller fait pareil, il est porte par la variante ;
     - les ages des oreillers 2 a 4 partent en proprietes de ligne
       properties[Pillow N age], rattachees au formulaire par l'attribut form. */
(function () {
  var HEIGHTS = ['2 to 4 cm', '4 to 6 cm', '6 to 9 cm'];
  var BLURBS = [
    'A very first pillow, nice and low.',
    'A little taller, for shoulders that are starting to grow.',
    'A bigger neck, and a little more height.'
  ];

  function idxFor(a) { return a <= 3 ? 0 : (a <= 8 ? 1 : 2); }
  function toArray(x) { return Array.prototype.slice.call(x); }

  /* La fenetre du guide vit sur <body> : la colonne de la fiche a un ancetre
     transforme (.product__info-wrapper.scroll-trigger.animate--slide-in garde un
     transform meme une fois l'animation finie), et un ancetre transforme devient le
     bloc conteneur de tout descendant en position:fixed. Restee dans la colonne,
     la fenetre s'ouvrirait etroite et collee a droite au lieu de couvrir l'ecran.
     On prefere donc toujours le noeud deja pose sur <body>. */
  function trouverGuide(gid) {
    var l = document.querySelectorAll('[data-hb-guidebox]'), surBody = null, autre = null;
    for (var i = 0; i < l.length; i++) {
      if (gid && l[i].id && l[i].id !== gid) continue;
      if (l[i].parentNode === document.body) { if (!surBody) surBody = l[i]; }
      else if (!autre) autre = l[i];
    }
    return surBody || autre;
  }

  /* Ouverture : ecoute DELEGUEE sur document, jamais sur la boite.
     Dawn peut re-rendre la colonne par innerHTML, ce qui emporterait un ecouteur
     pose sur un noeud de la colonne. Les deux declencheurs passent par ici : le
     bouton en forme de regle de chaque ligne d'age, et le lien
     « See the dimensions of each size ». Ce dernier est un <a href> : sans
     preventDefault le clic reel suivrait le lien et chargerait /pages/size-guide,
     meme si la fenetre s'ouvrait au passage. Le href reste en place, c'est le repli
     sans JavaScript et il autorise le clic milieu. */
  document.addEventListener('click', function (e) {
    var t = e.target.closest && e.target.closest('[data-hb-guide]');
    if (!t) return;
    var b = t.closest('.hb-pdp');
    var g = trouverGuide(b ? b.getAttribute('data-hb-guidebox-id') : null);
    if (!g || typeof g.hbgOpen !== 'function') return;   /* pas encore arme : on laisse le lien faire */
    e.preventDefault();
    g.hbgOpen(parseInt(t.getAttribute('data-hb-guide'), 10) || 1);
  });

  function setup(box) {
    if (box.dataset.hbPdpReady === '1') return;
    box.dataset.hbPdpReady = '1';

    var info = box.closest('product-info') || document;
    var extras = box.querySelector('[data-hb-extras]');
    var ageWrap = box.querySelector('[data-hb-agewrap]');
    var ageLabel = box.querySelector('[data-hb-agelabel]');
    var rows = toArray(box.querySelectorAll('[data-hb-agerow]'));
    var one = box.getAttribute('data-age-one') || 'How old is your child?';
    var many = box.getAttribute('data-age-many') || 'What age for each pillow?';
    var firstAge = box.querySelector('[data-hb-age]');
    /* T2 : la liste des ages utiles EXCLUT la premiere option vide « Select their age ».
       Sans ce filtre, idxFor() renverrait l'index 0 et le guide des tailles comme
       ?age=5 poseraient la valeur vide au lieu de « 1 to 3 years ». */
    var vals = firstAge ? toArray(firstAge.options).map(function (o) { return o.value; })
                                                   .filter(function (v) { return v !== ''; }) : [];

    /* --- champs natifs : requetes a chaque fois, Dawn remplace <variant-selects>.
       Sa methode viewTransition INSERE le nouveau noeud AVANT l'ancien et laisse
       l'ancien en display:none pendant 500 ms. On ne lit donc que le noeud visible,
       sans quoi on relirait l'etat perime pendant une demi-seconde. --- */
    function liveSelects() {
      var all = toArray(info.querySelectorAll('variant-selects'));
      for (var i = 0; i < all.length; i++) {
        if (all[i].style.display !== 'none') return all[i];
      }
      return all[0] || null;
    }
    function natives(kind) {
      var v = liveSelects();
      return v ? toArray(v.querySelectorAll('input[data-hbp="' + kind + '"]')) : [];
    }
    function nativeValue(kind) {
      var hit = natives(kind).filter(function (i) { return i.checked; })[0];
      return hit ? hit.value : '';
    }
    function pushNative(kind, value) {
      var hit = natives(kind).filter(function (i) { return i.value === value; })[0];
      if (!hit || hit.checked) return;
      hit.checked = true;
      hit.dispatchEvent(new Event('change', { bubbles: true }));
    }

    /* --- palier choisi --- */
    function checkedPack() {
      return box.querySelector('.hb-pk__r:checked');
    }
    function count() {
      var r = checkedPack();
      var m = r ? (r.getAttribute('data-pack') || '').match(/\d+/) : null;
      return m ? Math.min(4, Math.max(1, parseInt(m[0], 10))) : 1;
    }

    function syncCards() {
      var r = checkedPack();
      toArray(box.querySelectorAll('[data-hb-pk]')).forEach(function (c) {
        c.classList.toggle('is-on', !!r && c.contains(r));
      });
      if (extras && r) {
        var card = r.closest('[data-hb-pk]');
        if (card && card.nextElementSibling !== extras) card.insertAdjacentElement('afterend', extras);
      }
    }

    function syncAgeRows() {
      var n = count();
      /* L'astuce « beaucoup de parents finissent avec un deuxieme » ne veut plus rien
         dire quand on en prend deja deux : on la masque des le palier 2. Le marqueur
         va sur la boite entiere, parce que .hb-tip est un frere de .hb-age, pas un
         enfant. La regle .hb-multi .hb-tip existe deja dans assets/hushly-buybox.css,
         feuille chargee sur la fiche comme sur l'accueil. */
      box.classList.toggle('hb-multi', n > 1);
      if (ageWrap) ageWrap.classList.toggle('is-multi', n > 1);
      if (ageLabel) ageLabel.textContent = n > 1 ? many : one;
      rows.forEach(function (row, i) {
        var on = (i + 1) <= n;
        row.hidden = !on;
        var sel = row.querySelector('select');
        if (sel && sel.hasAttribute('data-hb-ageprop')) sel.disabled = !on;
      });
    }

    function syncAll() { syncCards(); syncAgeRows(); }

    /* etat de depart : on aligne l'affichage sur ce que Dawn a deja choisi */
    (function start() {
      var pv = nativeValue('pack');
      if (pv) {
        var r = box.querySelector('.hb-pk__r[data-pack="' + (window.CSS && CSS.escape ? CSS.escape(pv) : pv) + '"]');
        if (!r) {
          r = toArray(box.querySelectorAll('.hb-pk__r')).filter(function (x) {
            return x.getAttribute('data-pack') === pv;
          })[0];
        }
        if (r && !r.disabled) r.checked = true;
      }
      /* T2 : on ne recopie l'age de Dawn dans le selecteur que s'il porte DEJA une
         valeur. Vide, il attend le choix du parent : la variante par defaut de Dawn
         (« 1 to 3 years ») ne doit pas se reinstaller a sa place au chargement. */
      var av = nativeValue('age');
      /* 12/10/2026 (Antonin) : le menu n'a plus d'option vide et s'ouvre sur 3 to 8 years.
         C'est lui qui commande : si Dawn porte un autre age (variante par defaut 1 to 3), on le pousse. */
      if (firstAge && firstAge.value && av !== firstAge.value) pushNative('age', firstAge.value);
      syncAll();
    })();

    box.addEventListener('change', function (e) {
      var t = e.target;
      if (!t) return;
      if (t.classList && t.classList.contains('hb-pk__r')) {
        syncAll();
        pushNative('pack', t.getAttribute('data-pack'));
        return;
      }
      if (t.hasAttribute && t.hasAttribute('data-hb-age')) {
        pushNative('age', t.value);
      }
    });

    /* --- point d'entree public, pour le quiz de la section hushly-fit ---
       Trois portes, toutes equivalentes, toutes sur la ligne d'age du 1er oreiller
       (celle qui porte la variante) :
         1. window.hushlySetAge('3 to 8 years')  ou  window.hushlySetAge(5)
         2. document.dispatchEvent(new CustomEvent('hushly:set-age',
              { detail: { age: '3 to 8 years' } }))   ou   { detail: { years: 5 } }
         3. le parametre d'URL ?age=3%20to%208%20years   ou   ?child_age=5
       Un nombre est traduit par la meme regle que la modale : <=3, <=8, sinon.
       La fonction renvoie true si la valeur a ete posee, false sinon. Elle emet un
       change, donc Dawn recalcule la variante, le prix et le bouton d'achat. */
    function applyAge(v) {
      if (!firstAge || v === undefined || v === null || v === '') return false;
      var want = null;
      var n = parseInt(v, 10);
      if (String(v).match(/^\s*\d+\s*$/) && !isNaN(n)) {
        want = vals[idxFor(n)];
      } else {
        var t = String(v).trim().toLowerCase();
        for (var i = 0; i < vals.length; i++) {
          if (String(vals[i]).trim().toLowerCase() === t) { want = vals[i]; break; }
        }
      }
      if (!want) return false;
      firstAge.value = want;
      firstAge.dispatchEvent(new Event('change', { bubbles: true }));
      return firstAge.value === want;
    }
    box.hushlySetAge = applyAge;
    window.hushlySetAge = applyAge;
    document.addEventListener('hushly:set-age', function (e) {
      var d = (e && e.detail) || {};
      applyAge(d.age !== undefined ? d.age : d.years);
    });
    /* 08/10/2026 : le quiz envoie aussi ?pack=N&ages=5,10 quand le parent a coche
       plusieurs ages. On coche le palier N (meme chemin qu'un tap sur la carte), on
       attend que Dawn ait pris le palier, puis on pose l'age du 1er oreiller (variante)
       et ceux des oreillers 2 a N (proprietes de ligne, marquees comme choisies pour
       que le miroir T28 ne les ecrase pas ; la housse du meme numero suit). */
    function applyPack(n, list, first) {
      var r = box.querySelector('.hb-pk__r[data-pack="' + n + ' pillows"]');
      if (!r || r.disabled) { if (first !== null) applyAge(first); return; }
      r.checked = true;
      r.dispatchEvent(new Event('change', { bubbles: true }));
      var want = r.getAttribute('data-pack'), tries = 0;
      (function attendre() {
        if (nativeValue('pack') !== want && ++tries < 40) { setTimeout(attendre, 100); return; }
        setTimeout(function () {
          if (first !== null) applyAge(first);
          for (var i = 1; i < list.length && i < n; i++) {
            var s = box.querySelector('select[data-hb-ageprop="' + (i + 1) + '"]');
            var a = parseInt(list[i], 10);
            if (!s || isNaN(a)) continue;
            var val = vals[idxFor(a)];
            if (!val) continue;
            s.disabled = false;
            s.value = val;
            s.dispatchEvent(new Event('change', { bubbles: true }));
          }
        }, 250);
      })();
    }
    (function fromUrl() {
      try {
        var q = new URLSearchParams(window.location.search);
        var v = q.get('age');
        if (v === null) v = q.get('child_age');
        var pk = parseInt(q.get('pack') || '', 10);
        if (pk >= 2 && pk <= 4) {
          var list = (q.get('ages') || '').split(',').filter(function (x) { return x !== ''; });
          applyPack(pk, list, v !== null ? v : (list[0] || null));
          return;
        }
        if (v !== null) applyAge(v);
      } catch (err) { /* navigateur sans URLSearchParams : on ne fait rien */ }
    })();

    /* --- fenetre « on trouve la bonne taille » --- */
    var boxg = trouverGuide(box.getAttribute('data-hb-guidebox-id'));
    if (!boxg) return;
    /* on la sort de la colonne des l'armement, pas a l'ouverture : voir trouverGuide */
    if (boxg.parentNode !== document.body) document.body.appendChild(boxg);

    var age = 4, forRow = 1;
    var val = boxg.querySelector('[data-hb-ageval]');
    var who = boxg.querySelector('[data-hb-guidewho]');
    var oSize = boxg.querySelector('[data-hb-guidesize]');
    var oH = boxg.querySelector('[data-hb-guideheight]');
    var oD = boxg.querySelector('[data-hb-guidedesc]');
    var minus = boxg.querySelector('[data-hb-age-minus]');
    var plus = boxg.querySelector('[data-hb-age-plus]');

    function draw() {
      var i = idxFor(age);
      val.textContent = age;
      oSize.textContent = vals[i] || '';
      oH.textContent = HEIGHTS[i] || '';
      oD.textContent = BLURBS[i] || '';
      minus.disabled = age <= 1;
      plus.disabled = age >= 14;
      who.textContent = count() > 1 ? ('pillow no.' + forRow) : 'the pillow';
      /* le recapitulatif des trois tailles : on marque celle qui correspond a l'age
         affiche, pour que les deux moities de la fenetre se repondent */
      var lignes = boxg.querySelectorAll('[data-hb-dimrow]');
      for (var d = 0; d < lignes.length; d++) {
        lignes[d].classList.toggle('is-on',
          parseInt(lignes[d].getAttribute('data-hb-dimrow'), 10) === i);
      }
    }
    function open(n) {
      forRow = n; boxg.hidden = false;
      /* le verrou de defilement se pose sur html ET sur body : overflow:hidden sur
         l'un des deux seulement ne verrouille rien ici. La classe est definie dans
         le bloc, le style en ligne reste en second garde-fou. */
      document.documentElement.classList.add('hbg-lock');
      document.body.classList.add('hbg-lock');
      document.documentElement.style.overflow = 'hidden';
      draw();
    }
    function close() {
      boxg.hidden = true;
      document.documentElement.classList.remove('hbg-lock');
      document.body.classList.remove('hbg-lock');
      document.documentElement.style.overflow = '';
    }
    /* l'ouverture est appelee par l'ecoute deleguee posee sur document, plus haut */
    boxg.hbgOpen = open;

    if (boxg.hbgArme) return;
    boxg.hbgArme = 1;
    boxg.addEventListener('click', function (e) {
      var t = e.target;
      /* clic sur la fenetre elle-meme, donc a cote de la boite : on ferme. Second
         garde-fou si le voile .hbg__bd venait a redisparaitre sous div:empty. */
      if (t === boxg) { close(); return; }
      if (t.closest('[data-hb-guideclose]')) { close(); return; }
      if (t.closest('[data-hb-age-minus]')) { if (age > 1) { age--; draw(); } return; }
      if (t.closest('[data-hb-age-plus]')) { if (age < 14) { age++; draw(); } return; }
      if (t.closest('[data-hb-guideok]')) {
        var row = box.querySelector('[data-hb-agerow="' + forRow + '"]');
        var sel = row && row.querySelector('select');
        if (sel) { sel.value = vals[idxFor(age)]; sel.dispatchEvent(new Event('change', { bubbles: true })); }
        close();
      }
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !boxg.hidden) close(); });
  }


  /* ------------------------------------------------------------------
     Le reste de la colonne d'achat, hors bloc d'offre :
       P12 le montant dans le bouton d'achat, qui suit le palier ;
       P14 la date de retour, envoyee en propriete de ligne seulement si elle est remplie ;
       P16 la pagination du petit carrousel d'avis.
     Chacun se branche seul et ne fait rien si son balisage n'est pas la. ------------------ */

  function buyLabel(box) {
    var info = box.closest('product-info');
    if (!info) return;
    var btn = info.querySelector('.product-form__submit');
    var span = btn && btn.querySelector('span');
    if (!span) return;
    var prices = {};
    try { prices = JSON.parse(box.getAttribute('data-hb-prices') || '{}'); } catch (e) { return; }
    var base = (window.variantStrings && window.variantStrings.addToCart) ||
               (span.textContent || '').split(' \u00b7 ')[0].trim();
    function apply() {
      /* en rupture Dawn ecrit « Sold out » : on n'y touche pas */
      if (btn.hasAttribute('disabled')) return;
      var r = box.querySelector('.hb-pk__r:checked');
      var p = r ? prices[r.getAttribute('data-pack')] : null;
      var want = base + (p ? ' \u00b7 ' + p : '');
      if (span.textContent !== want) span.textContent = want;
    }
    box.addEventListener('change', function () { setTimeout(apply, 0); });
    /* Dawn remet le libelle d'origine a chaque changement de variante
       (toggleSubmitButton), on repose le montant des qu'il le fait */
    if (window.MutationObserver) {
      new MutationObserver(apply).observe(span, { childList: true, characterData: true, subtree: true });
      new MutationObserver(apply).observe(btn, { attributes: true, attributeFilter: ['disabled'] });
    }
    apply();
  }

  function returnDate(root) {
    var vis = (root || document).querySelector('[data-pdp-returndate]');
    var prop = (root || document).querySelector('[data-pdp-returnprop]');
    if (!vis || !prop) return;
    function sync() {
      var v = (vis.value || '').trim();           /* le champ date rend yyyy-mm-dd */
      var m = v.match(/^(\d{4})-(\d{2})-(\d{2})$/);
      prop.value = m ? (m[3] + '/' + m[2] + '/' + m[1]) : v;   /* le panier lit du dd/mm/yyyy */
      prop.disabled = !v;                          /* vide = aucune propriete envoyee */
    }
    vis.addEventListener('input', sync);
    vis.addEventListener('change', sync);
    sync();
  }

  function reviewDots(root) {
    var wrap = (root || document).querySelector('[data-pdp-reviews]');
    if (!wrap) return;
    var rail = wrap.querySelector('.pdpr__rail');
    var slides = toArray(wrap.querySelectorAll('[data-pdp-slide]'));
    var dots = toArray(wrap.querySelectorAll('[data-pdp-dot]'));
    if (!rail || !slides.length) return;

    /* Le point marque la carte la plus proche du bord gauche du rail. On lit la
       position de defilement plutot qu'une classe : c'est ce qui permet au doigt
       de commander, la classe ne suivait que le clic. */
    function marque() {
      var x = rail.scrollLeft, best = 0, d = Infinity;
      slides.forEach(function (s, i) {
        var e = Math.abs(s.offsetLeft - rail.offsetLeft - x);
        if (e < d) { d = e; best = i; }
      });
      dots.forEach(function (b, i) {
        b.setAttribute('aria-current', i === best ? 'true' : 'false');
      });
      slides.forEach(function (s, i) { s.classList.toggle('is-on', i === best); });
    }

    var attente = false;
    rail.addEventListener('scroll', function () {
      if (attente) return;
      attente = true;
      /* requestAnimationFrame ne se declenche pas dans un onglet masque */
      var suite = function () { attente = false; marque(); };
      if (document.hidden) { suite(); } else { requestAnimationFrame(suite); }
    }, { passive: true });

    wrap.addEventListener('click', function (e) {
      var b = e.target.closest && e.target.closest('[data-pdp-dot]');
      if (!b) return;
      var i = dots.indexOf(b);
      if (i < 0) return;
      var x = slides[i].offsetLeft - rail.offsetLeft;
      /* On marque tout de suite plutot que d'attendre l'evenement scroll : le defilement
         est lisse, donc l'evenement arrive apres l'animation, et sur un rail deja au bout
         il peut ne jamais arriver. Le doigt, lui, reste servi par l'ecoute scroll. */
      dots.forEach(function (x2, k) { x2.setAttribute('aria-current', k === i ? 'true' : 'false'); });
      slides.forEach(function (s, k) { s.classList.toggle('is-on', k === i); });
      if (rail.scrollTo) { rail.scrollTo({ left: x, behavior: 'smooth' }); }
      else { rail.scrollLeft = x; }
    });

    marque();
  }

  function boot(root) {
    toArray((root || document).querySelectorAll('.hb-pdp')).forEach(function (box) {
      setup(box);
      if (box.dataset.hbPdpExtra !== '1') { box.dataset.hbPdpExtra = '1';
        /* buyLabel(box) : le montant dans le bouton d'achat est DESACTIVE a la demande
           d'Antonin. La fonction reste au-dessus, il suffit de rappeler cette ligne
           pour le remettre. Sans elle, Dawn ecrit son libelle et rien ne le surcharge. */
      }
    });
    returnDate(root);
    reviewDots(root);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { boot(); }, { once: true });
  } else { boot(); }
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();


/* ------------------------------------------------------------------
   T28 (11/09/2026). LES AGES SUIVENT LE 1ER OREILLER.
   Test consommateur : le parent choisit « 3 to 8 years » puis le pack 3 ; les
   selecteurs des oreillers 2 et 3 s'activaient sur la PREMIERE valeur de la
   liste (« 1 to 3 years »), la housse offerte aussi. La commande partait avec
   deux oreillers et une housse de la mauvaise taille, sans que rien ne l'affiche.
   Regle : tant que le parent n'a pas touche un selecteur (oreiller 2 a 4) ou une
   carte de housse, ils recopient l'age du 1er oreiller, a chaque changement
   d'age ou de palier. Des qu'il les touche (freres et soeurs d'ages differents),
   son choix est garde. Meme code sur la fiche et sur le bloc de l'accueil.
   ------------------------------------------------------------------ */
(function () {
  if (window.__hkAgeMirror) return;
  window.__hkAgeMirror = true;
  function esc(v) { return (window.CSS && CSS.escape) ? CSS.escape(v) : String(v).replace(/"/g, '\\"'); }
  function firstSel(b) {
    return b.querySelector('select[data-hb-age]') || b.querySelector('select.hb-age__s:not([data-hb-ageprop])');
  }
  function mirror(b) {
    var f = firstSel(b);
    if (!f || !f.value) return;
    var v = f.value;
    Array.prototype.forEach.call(b.querySelectorAll('select[data-hb-ageprop]'), function (s) {
      if (s.hasAttribute('data-hb-touched')) return;
      if (Array.prototype.some.call(s.options, function (o) { return o.value === v; })) s.value = v;
    });
    /* 27/09/2026 : une housse par oreiller, la housse N prend la taille de l'oreiller N
       (celle du 1er tant que l'oreiller N n'en a pas). */
    Array.prototype.forEach.call(b.querySelectorAll('[data-hb-covcard]'), function (card) {
      if (card.hasAttribute('data-hb-touched')) return;
      var cn = card.getAttribute('data-hb-covcard'), vv = v;
      /* 12/10/2026 (Antonin) : pack 2 = une seule taie, elle suit l'oreiller 2 (regle unique fiche, tiroir, quiz). */
      var cw = card.closest('[data-hb-covwrap]');
      if (cn === '1' && cw && cw.getAttribute('data-hb-n') === '1') cn = '2';
      var ps = cn && cn !== '1' ? b.querySelector('select[data-hb-ageprop="' + cn + '"]') : null;
      if (ps && !ps.disabled && ps.value) vv = ps.value;
      var chip = card.querySelector('[data-hb-covchip][data-val="' + esc(vv) + '"]');
      if (!chip) return;
      Array.prototype.forEach.call(card.querySelectorAll('[data-hb-covchip]'), function (x) {
        x.classList.remove('is-on'); x.setAttribute('aria-pressed', 'false');
      });
      chip.classList.add('is-on'); chip.setAttribute('aria-pressed', 'true');
      var inp = card.querySelector('[data-hb-covprop]');
      if (inp) inp.value = vv;
    });
  }
  document.addEventListener('change', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    var b = t.closest('.hb');
    if (!b) return;
    if (t.matches('select[data-hb-ageprop]')) t.setAttribute('data-hb-touched', '1'); /* 27/09 : et la housse du meme numero suit */
    setTimeout(function () { mirror(b); }, 0);
  }, true);
  document.addEventListener('click', function (e) {
    var chip = e.target && e.target.closest && e.target.closest('[data-hb-covchip]');
    if (!chip) return;
    var card = chip.closest('[data-hb-covcard]');
    if (card) card.setAttribute('data-hb-touched', '1');
  }, true);
  function init() { Array.prototype.forEach.call(document.querySelectorAll('.hb'), mirror); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();


/* ------------------------------------------------------------------
   T2 (12/09/2026). AUCUN AGE PAR DEFAUT, ET PAS D'AJOUT SANS AGE.
   Test consommateur : « How old is your child? » arrivait pre-rempli sur
   « 1 to 3 years ». Un parent qui n'y touchait pas ajoutait au panier
   « 1 pillow / 1 to 3 years » et recevait la mauvaise hauteur.
   Le gabarit pose desormais une premiere option vide « Select their age »,
   selectionnee par defaut (sauf si l'URL porte deja une variante), sur le
   1er oreiller, sur les oreillers 2 a 4 des packs et sur les housses offertes.
   Ce bloc ferme la porte de sortie : tant qu'un age visible reste vide, le
   clic sur « Add to cart » (vrai bouton, barre collante, ou envoi du
   formulaire) est arrete, le message « Choose an age first » s'affiche et la
   page redescend sur le champ qui manque. Rien n'est retire : le bouton reste
   en place, il refuse simplement de partir incomplet.
   La barre collante mobile dit « Choose size » dans le meme etat : les deux
   lisent la meme valeur, celle du selecteur.
   ------------------------------------------------------------------ */
(function () {
  if (window.__hkAgeGate) return;
  window.__hkAgeGate = true;

  function proche(n, sel) {
    while (n && n.nodeType !== 1) n = n.parentNode;
    return n && n.closest ? n.closest(sel) : null;
  }
  function laBoite() { return document.querySelector('.hb-pdp'); }

  /* renvoie le premier champ d'age visible et vide, ou null si tout est renseigne */
  function manque(b) {
    if (!b) return null;
    var f = b.querySelector('select[data-hb-age]');
    if (f && !f.value) return f;
    var sel = null;
    Array.prototype.some.call(b.querySelectorAll('select[data-hb-ageprop]'), function (s) {
      if (!s.disabled && !s.value) { sel = s; return true; }
      return false;
    });
    if (sel) return sel;
    var cov = null;
    Array.prototype.some.call(b.querySelectorAll('[data-hb-covcard]'), function (card) {
      if (card.hidden) return false;
      if (!card.querySelector('[data-hb-covchip].is-on')) { cov = card; return true; }
      return false;
    });
    return cov;
  }

  function boutons() {
    return Array.prototype.slice.call(document.querySelectorAll('button[name="add"], .product-form__submit'));
  }

  /* etat visible : le message et l'aspect du bouton suivent le manque, sans jamais
     reecrire une valeur identique (sinon l'observateur ci-dessous tournerait en rond) */
  function refresh() {
    var b = laBoite();
    if (!b) return;
    var m = manque(b);
    /* le message ne s'invite pas au chargement : il parait apres une tentative
       d'ajout arretee, et disparait des que le manque est comble */
    var note = b.querySelector('[data-hb-agenote]');
    if (note && !m && !note.hidden) { note.hidden = true; note.classList.remove('is-on'); }
    var al = document.querySelector('[data-hk-agealert]');
    if (al && !m && !al.hidden) al.hidden = true;
    boutons().forEach(function (btn) {
      var veut = m ? 'true' : 'false';
      if (btn.getAttribute('data-hk-needage') !== veut) btn.setAttribute('data-hk-needage', veut);
    });
  }

  /* 21/09/2026 (brief conversion) : cliquer « Add to basket » sans age ne fait plus sauter la page.
     Test mobile : le visiteur etait renvoye tout en haut du bloc d'offre et pouvait croire que le
     bouton ne marchait pas. Desormais, quand le bouton clique est a l'ecran, un message apparait
     JUSTE AU-DESSUS de lui, avec un lien qui remonte au choix de l'age seulement si on le touche.
     Le blocage reste identique (aucun age n'est jamais preselectionne). Quand le clic vient de la
     barre collante (vrai bouton hors ecran), on garde l'ancien comportement : remonter au champ. */
  function enVue(el) {
    if (!el) return false;
    var r = el.getBoundingClientRect();
    return r.width > 0 && r.bottom > 0 && r.top < window.innerHeight;
  }
  function aller(cible) {
    var doux = !(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
    /* 03/10/2026 : on centre le bloc de l'age dans la zone visible (entre l'en-tete et la barre
       d'achat du bas) au lieu de le coller a 120 px du haut. Avant : y = top + scrollY - 120. */
    var bloc = (cible.closest && cible.closest('[data-hb-agewrap]')) || cible;
    var r = bloc.getBoundingClientRect();
    var haut = 0, bas = window.innerHeight;
    var hd = document.querySelector('.section-header, sticky-header, .header-wrapper');
    if (hd) { haut = Math.min(Math.max(hd.getBoundingClientRect().height, 0), 140); }
    var sb = document.querySelector('.hk-sticky');
    if (sb && sb.offsetHeight && getComputedStyle(sb).display !== 'none') { bas = Math.min(bas, window.innerHeight - sb.offsetHeight); }
    var dispo = bas - haut;
    var marge = r.height < dispo ? (dispo - r.height) / 2 : 16;
    var y = r.top + window.scrollY - haut - marge;
    window.scrollTo({ top: Math.max(0, y), behavior: doux ? 'smooth' : 'auto' });
    cible.classList.add('hk-flash');
    setTimeout(function () { cible.classList.remove('hk-flash'); }, 1600);
    if (cible.focus) { try { cible.focus({ preventScroll: true }); } catch (e) {} }
  }
  function styleAlerte() {
    if (document.getElementById('hk-agealert-css')) return;
    var s = document.createElement('style'); s.id = 'hk-agealert-css';
    s.textContent = '.hk-agealert{margin:0 0 10px;padding:8px 12px;border-radius:12px;background:#FDECEA;color:#A8241C;' +
      'font-size:14px;font-weight:600;line-height:1.35;display:flex;flex-wrap:wrap;align-items:center;justify-content:center;' +
      'gap:0 10px;text-align:center}.hk-agealert[hidden]{display:none}' +
      '.hk-agealert__go{border:0;background:none;padding:0 2px;min-height:44px;font:inherit;font-weight:800;color:#193953;' +
      'text-decoration:underline;text-underline-offset:3px;cursor:pointer}' +
      '.hk-agealert.is-pulse{animation:hkAgePulse .45s ease}' +
      '@keyframes hkAgePulse{0%{transform:scale(.97)}60%{transform:scale(1.02)}100%{transform:scale(1)}}' +
      '@media (prefers-reduced-motion:reduce){.hk-agealert.is-pulse{animation:none}}';
    document.head.appendChild(s);
  }
  function alerte(btn) {
    styleAlerte();
    var zone = (btn.closest && btn.closest('.product-form__buttons')) || btn;
    var a = document.querySelector('[data-hk-agealert]');
    if (!a) {
      a = document.createElement('p');
      a.className = 'hk-agealert'; a.setAttribute('data-hk-agealert', ''); a.setAttribute('role', 'alert');
      a.innerHTML = '<span>Choose an age first</span><button type="button" class="hk-agealert__go">Select their age &uarr;</button>';
      zone.parentNode.insertBefore(a, zone);
      a.querySelector('button').addEventListener('click', function (ev) {
        ev.preventDefault();
        var bx = laBoite(); if (!bx) return;
        aller(manque(bx) || bx.querySelector('[data-hb-agewrap]') || bx);
      });
    }
    a.hidden = false;
    a.classList.remove('is-pulse'); void a.offsetWidth; a.classList.add('is-pulse');
  }
  function signaler(b, m, btn) {
    var note = b.querySelector('[data-hb-agenote]');
    if (note) { note.hidden = false; note.classList.add('is-on'); }
    var cible = m || b.querySelector('[data-hb-agewrap]') || b;
    if (btn && enVue(btn)) {
      cible.classList.add('hk-flash');
      setTimeout(function () { cible.classList.remove('hk-flash'); }, 1600);
      alerte(btn);
      return;
    }
    aller(cible);
  }

  /* deux barrieres : le clic sur le bouton, et l'envoi du formulaire. En phase de
     capture et avec stopImmediatePropagation, donc avant le product-form de Dawn,
     y compris pour le clic synthetique de la barre collante. */
  document.addEventListener('click', function (e) {
    var btn = proche(e.target, 'button[name="add"], .product-form__submit');
    if (!btn) return;
    var b = laBoite(); if (!b) return;
    var m = manque(b); if (!m) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    signaler(b, m, btn);
  }, true);

  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (!f || !f.matches || !f.matches('form[action*="/cart/add"]')) return;
    var b = laBoite(); if (!b) return;
    var m = manque(b); if (!m) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    signaler(b, m, f.querySelector('button[name="add"], .product-form__submit'));
  }, true);

  document.addEventListener('change', function () { setTimeout(refresh, 0); });
  document.addEventListener('click', function () { setTimeout(refresh, 0); });
  document.addEventListener('shopify:section:load', function () { setTimeout(refresh, 0); });
  if (window.MutationObserver) {
    var cible = document.querySelector('product-info') || document.body;
    var attente = null;
    new MutationObserver(function () {
      if (attente) return;
      attente = setTimeout(function () { attente = null; refresh(); }, 60);
    }).observe(cible, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', refresh);
  else refresh();
})();


/* ------------------------------------------------------------------
   T3 (12/09/2026). LE PRIX DU PALIER, DANS L'EN-TETE REMONTE EN MOBILE.
   Le gabarit rend un prix de depart dans l'en-tete de la fiche (.hb-p0),
   visible en mobile seulement. Il suit le palier coche, comme la barre
   collante : meme source, data-hb-prices, et le barre / la remise lus sur
   la carte cochee. ------------------------------------------------------------------ */
(function () {
  if (window.__hkHeadPrice) return;
  window.__hkHeadPrice = true;
  /* 21/09/2026 (Antonin) : « garde le prix pour 1 seul pillow ». Le prix de l'en-tete mobile
     ne suit plus le palier coche. Il reste celui rendu par le gabarit, product.price, donc le
     prix le plus bas du produit, celui d'UN oreiller (35,95 face a 48,99, Save 27%). Le prix
     du palier choisi reste affiche sous le bloc d'offre, dans la barre collante et au panier.
     Pour revenir en arriere : supprimer le return ci-dessous. */
  return;
  function maj() {
    var p0 = document.querySelector('[data-hb-p0]');
    var box = document.querySelector('.hb-pdp');
    if (!p0 || !box) return;
    var prices = {};
    try { prices = JSON.parse(box.getAttribute('data-hb-prices') || '{}'); } catch (e) {}
    var r = box.querySelector('.hb-pk__r:checked');
    var card = r && r.closest('[data-hb-pk]');
    var pack = (r && r.getAttribute('data-pack')) || '';
    var now = prices[pack] || '';
    if (!now && card) { var nb = card.querySelector('.hb-pk__price b'); now = nb ? nb.textContent.trim() : ''; }
    var sEl = card && card.querySelector('.hb-pk__price s');
    var was = sEl ? sEl.textContent.trim() : '';
    var sv = card ? (card.innerText.match(/Save\s+(\d+%)/i) || [])[1] : '';
    var v = p0.querySelector('[data-hb-p0v]'), w = p0.querySelector('[data-hb-p0w]'), s = p0.querySelector('[data-hb-p0s]');
    if (v && now && v.textContent !== now) v.textContent = now;
    if (w) { if (w.textContent !== was) w.textContent = was; w.hidden = !was; }
    if (s) { var txt = sv ? 'Save ' + sv : ''; if (s.textContent !== txt) s.textContent = txt; s.hidden = !sv; }
  }
  document.addEventListener('change', function () { setTimeout(maj, 0); });
  document.addEventListener('shopify:section:load', function () { setTimeout(maj, 0); });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', maj);
  else maj();
})();


/* HUSHLY 21/09/2026 : le pack touche reste sous le doigt.
   En changeant de pack, la carte ouverte au-dessus (ses ages, ses housses) se referme : tout remonte de
   200 a 400 px et la carte touchee sortait parfois de l'ecran. On mesure sa position au moment du clic
   et on compense le defilement pendant que la page se recompose (Dawn re-rend en ~200 ms). */
(function () {
  if (window.__hkPackAnchor) return; window.__hkPackAnchor = true;
  var last = 0;
  document.addEventListener('click', function (e) {
    var card = e.target && e.target.closest && e.target.closest('[data-hb-pk]');
    if (!card) return;
    var now = Date.now();
    if (now - last < 350) return;          /* label + radio = deux clics pour un seul geste */
    last = now;
    /* 29/09/2026 (Antonin : « rollbacks » en descendant apres le choix d'un pack). La compensation
       tournait 0,8 s et prenait le defilement du visiteur pour un saut de la page : elle le ramenait
       en arriere (jusqu'a 876 px, 3 a 4 fois par geste). Elle s'arrete maintenant des que le doigt,
       la molette ou le clavier font defiler. */
    var y0 = card.getBoundingClientRect().top, stop = false;
    function lache() { stop = true; }
    var evs = ['touchstart', 'touchmove', 'wheel', 'keydown'];
    evs.forEach(function (t) { window.addEventListener(t, lache, { passive: true, capture: true }); });
    setTimeout(function () { evs.forEach(function (t) { window.removeEventListener(t, lache, { capture: true }); }); }, 900);
    function fix() {
      if (stop || !card.isConnected) return;
      var d = card.getBoundingClientRect().top - y0;
      if (Math.abs(d) > 2) window.scrollBy(0, d);
    }
    requestAnimationFrame(fix);
    [80, 220, 450, 800].forEach(function (ms) { setTimeout(fix, ms); });
  }, true);

  /* Clavier (fleches sur les packs) : Dawn re-rend le bloc et le focus tombait hors des packs.
     On garde la carte en place et on rend le focus au pack choisi, sans faire defiler. */
  var kbAt = 0;
  document.addEventListener('keydown', function (e) {
    if (/^Arrow/.test(e.key) && e.target && e.target.closest && e.target.closest('[data-hb-pk]')) kbAt = Date.now();
  }, true);
  document.addEventListener('change', function (e) {
    var card = e.target && e.target.closest && e.target.closest('[data-hb-pk]');
    if (!card || !kbAt || Date.now() - kbAt > 1000) return;
    kbAt = 0;
    var y0 = card.getBoundingClientRect().top;
    function keep() {
      var d = card.getBoundingClientRect().top - y0;
      if (Math.abs(d) > 2) window.scrollBy(0, d);
      var r = card.querySelector('input[type=radio]');
      var a = document.activeElement;
      if (r && a !== r && (!a || a === document.body || !a.closest || !a.closest('[data-hb-pk]'))) {
        try { r.focus({ preventScroll: true }); } catch (x) {}
        d = card.getBoundingClientRect().top - y0;
        if (Math.abs(d) > 2) window.scrollBy(0, d);
      }
    }
    requestAnimationFrame(keep);
    [80, 220, 450, 800].forEach(function (ms) { setTimeout(keep, ms); });
  }, true);
})();
